<!--collapsible panel bar goes here-->
<kendo-panelbar #panelbar>
  <kendo-panelbar-item [expanded]="true">
    <ng-template kendoPanelBarItemTitle>
      <span>{{sampleRequestTxt.sampleSelectionLbl?sampleRequestTxt.sampleSelectionLbl:sampleRequestGrid.sampleSelectionLbl}}</span>
      <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
            *ngIf="!sampleItems.isSampleSelectionPanelValid && sampleItems.isContinueClicked"></span>
      <span class="k-icon k-i-check-circle k-i-checkmark-circle"
            *ngIf="sampleItems.isSampleSelectionPanelValid && sampleItems.isContinueClicked"
            style="color:green;font-weight:600"></span>
    </ng-template>
    <ng-template kendoPanelBarContent>
      <form [formGroup]="sampleRequestForm" class="margin-10">

        <div class="row top">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="lbl" [for]="finishCategoryLBL">{{sampleRequestTxt.finishCategoryLbl?sampleRequestTxt.finishCategoryLbl:sampleRequestGrid.finishCategoryLbl}}</label>
              <kendo-multiselect [data]="getSampleCategory"
                                 textField="categoryName"
                                 valueField="categoryId"
                                 class="kendoInput txtSizePwa"
                                 formControlName="finishCategory"
                                 [filterable]="true"
                                 (filterChange)="handleFinishCategoryFilter($event)"
                                 (valueChange)="finishCategoryLeave()">
                <ng-template kendoMultiSelectItemTemplate let-dataList>
                  <span class="template">{{dataList.categoryName}}</span>
                </ng-template>
              </kendo-multiselect>
            </div>
          </div>
        </div>
      </form>
      <br />
      <section class="margin-10">
        <kendo-grid [data]="sampleRequestGridView1"
                    class="sampleRequestGridCls"
                    [sortable]="true"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="true"
                    [sort]="sampleRequestGridstate1.sort"
                    (sortChange)="sampleRequestGridSortChange1($event)"
                    [pageable]="{ buttonCount: 5, info: true, responsive: true, pageSizes:[50,75,100] }"
                    [pageSize]="sampleRequestGridstate1.take"
                    [skip]="sampleRequestGridstate1.skip"
                    [columnMenu]="false"
                    (pageChange)="sampleRequestGridPageChange1($event)"
                    (dataStateChange)="sampleRequestDataStateChange1($event)"
                    [filter]="sampleRequestGridstate1.filter"
                    [loading]="sampleRequestgrid1Loading">

          <ng-template kendoGridToolbarTemplate>
            <input placeholder="Search in all columns..."
                   kendoTextBox
                   (input)="onFilterSampleRequest($event.target.value)" class="pwaSampleRequestSearch" />
          </ng-template>

          <kendo-grid-column media="(min-width: 1050px)" field="imagePath" title="{{sampleRequestTxt.imageLbl?sampleRequestTxt.imageLbl:sampleRequestGrid.imageLbl}}"
                             [width]="75" [headerClass]="'wrapheader-sample-request-grid'" [filterable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="sample-grid-img-zoom" *ngIf="dataItem.r_VALUE && dataItem.g_VALUE && dataItem.b_VALUE">
                <div style="width:50px; height:50px;" (click)="imageLarge(dataItem,'rgb')" style.background-color="rgb({{dataItem.r_VALUE}}, {{dataItem.g_VALUE}}, {{dataItem.b_VALUE}})"></div>
              </div>
              <div class="sample-grid-img-zoom" *ngIf="dataItem.absoluteURL">
                <img src="{{dataItem.absoluteURL}}" (click)="imageLarge(dataItem,'absolute')" alt="" width="50" height="50" />
              </div>
              <div class="sample-grid-img-zoom" *ngIf="dataItem.imagePath">
                <img src="{{imageUrl}}/{{dataItem.imagePath}}" (click)="imageLarge(dataItem, 'path')" alt="" width="50" height="50">
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="categoryName" title="{{sampleRequestTxt.categoryLbl?sampleRequestTxt.categoryLbl:sampleRequestGrid.categoryLbl}}"
                             [filterable]="true" [width]="175" [headerClass]="'wrapheader-sample-request-grid'">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="subCategoryDescription" title="{{sampleRequestTxt.productLbl?sampleRequestTxt.productLbl:sampleRequestGrid.productLbl}}"
                             [filterable]="true" [width]="315" [headerClass]="'wrapheader-sample-request-grid'">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="colorCode" title="{{sampleRequestTxt.colorCodeLbl?sampleRequestTxt.colorCodeLbl:sampleRequestGrid.colorCodeLbl}}"
                             [filterable]="true"[width]="150" [sortable]="true"[headerClass]="'wrapheader-sample-request-grid'">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="stockNum" title="{{sampleRequestTxt.stockNumLbl?sampleRequestTxt.stockNumLbl:sampleRequestGrid.stockNumLbl}}"
                             [filterable]="false" [width]="75" [sortable]="false" [headerClass]="'wrapheader-sample-request-grid'">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="maxQtyCanBeOrdered" title="{{sampleRequestTxt.maxQtyLbl?sampleRequestTxt.maxQtyLbl:sampleRequestGrid.maxQtyLbl}}"
                             [filterable]="false" [sortable]="false" [headerClass]="'wrapheader-sample-request-grid'" [hidden]="true">
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngIf="dataItem.maxQtyCanBeOrdered != 99999; else noListItemQty">
                {{dataItem.maxQtyCanBeOrdered}}
              </ng-container>
              <ng-template #noListItemQty>
              </ng-template>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <!--Need to show and hide based on KNA clothing selection-->

          <kendo-grid-column media="(min-width: 1050px)" [width]="120" [filterable]="false" [sortable]="false" field="quantity" title="{{sampleRequestTxt.quantityLbl?sampleRequestTxt.quantityLbl:sampleRequestGrid.quantityLbl}}" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <kendo-numerictextbox [value]="dataItem.quantity"
                                    [format]="'n'"
                                    [decimals]="decimals"
                                    [min]="1"
                                    [max]="dataItem.maxQtyCanBeOrdered"
                                    (valueChange)="handleItemQtyChanged($event, dataItem)"
                                    [autoCorrect]="autoCorrect"
                                    [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isEmptyQuantity}"
                                    class="QuantityCls gridControlsSize">
              </kendo-numerictextbox>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column [width]="135" field="onBackOrder" [headerClass]="'wrapheader-sample-request-grid'" title="{{sampleRequestTxt.onBackOrderLbl?sampleRequestTxt.onBackOrderLbl:sampleRequestGrid.onBackOrderLbl}}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="red" *ngIf="dataItem.onBackOrder">On Backorder</span>
            </ng-template>
          </kendo-grid-command-column>
          <kendo-grid-command-column media="(min-width: 1050px)" title="{{sampleRequestTxt.selectionLbl1?sampleRequestTxt.selectionLbl1:sampleRequestGrid.selectionLbl1}}" [width]="135" field="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoButton class="m-2 btn btn-success addBtn"
                      (click)="addSelection(dataItem)">
                {{sampleRequestTxt.addSelectionBtnLbl?sampleRequestTxt.addSelectionBtnLbl:sampleRequestGrid.addSelectionBtnLbl}}
              </button>
              <br>

            </ng-template>
          </kendo-grid-command-column>
          <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
              <kendo-pager-info></kendo-pager-info>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
              <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>-->
        </kendo-grid>
      </section>

      <div class="row">
        <div class="col-12 center">
          <button kendoButton primary="true" class="m-3" (click)="continueToReviewPanel()">
            {{sampleRequestTxt.continueLbl?sampleRequestTxt.continueLbl:sampleRequestGrid.continueLbl}}
          </button>
        </div>
      </div>

    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item [expanded]="true">
    <ng-template kendoPanelBarItemTitle>
      <span>{{sampleRequestTxt.reviewSelectionLbl?sampleRequestTxt.reviewSelectionLbl:sampleRequestGrid.reviewSelectionLbl}}</span>
      <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
            *ngIf="!sampleItems.isReviewSelectionPanelValid && sampleItems.isContinue"></span>
      <span class="k-icon k-i-check-circle k-i-checkmark-circle"
            *ngIf="sampleItems.isReviewSelectionPanelValid && sampleItems.isContinue"
            style="color:green;font-weight:600"></span>
    </ng-template>
    <ng-template kendoPanelBarContent>
      <section class="margin-10">
        <kendo-grid [data]="sampleRequestGridView"
                    class="sampleRequestGridCls"
                    [sortable]="true"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="true"
                    [sort]="sampleRequestGridstate.sort"
                    (sortChange)="sampleRequestGridSortChange($event)"
                    [pageable]="{ buttonCount: 5, info: true, responsive: true, pageSizes:[50,75,100] }"
                    [pageSize]="sampleRequestGridstate.take"
                    [skip]="sampleRequestGridstate.skip"
                    [columnMenu]="false"
                    (pageChange)="sampleRequestGridPageChange($event)"
                    (dataStateChange)="sampleRequestDataStateChange($event)"
                    [filter]="sampleRequestGridstate.filter"
                    [loading]="sampleRequestLoading">

          <ng-template kendoGridToolbarTemplate>
            <input placeholder="Search in all columns..."
                   kendoTextBox
                   (input)="onFilterReviewSampleRequest($event.target.value)" class="pwaSampleRequestSearch" />
          </ng-template>

          <kendo-grid-column media="(min-width: 1050px)" field="" title="{{sampleRequestTxt.imageLbl?sampleRequestTxt.imageLbl:sampleRequestGrid.imageLbl}}"
                             [width]="75">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="sample-grid-img-zoom" *ngIf="dataItem.r_VALUE && dataItem.g_VALUE && dataItem.b_VALUE">
                <div style="width:50px; height:50px;" (click)="imageLarge(dataItem,'rgb')" style.background-color="rgb({{dataItem.r_VALUE}}, {{dataItem.g_VALUE}}, {{dataItem.b_VALUE}})"></div>
              </div>
              <div class="sample-grid-img-zoom" *ngIf="dataItem.absoluteURL">
                <img src="{{dataItem.absoluteURL}}" (click)="imageLarge(dataItem,'absolute')" alt="" width="50" height="50" />
              </div>
              <div class="sample-grid-img-zoom" *ngIf="dataItem.imagePath">
                <img src="{{imageUrl}}/{{dataItem.imagePath}}" (click)="imageLarge(dataItem, 'path')" alt="" width="50" height="50">
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="categoryName" title="{{sampleRequestTxt.categoryLbl?sampleRequestTxt.categoryLbl:sampleRequestGrid.categoryLbl}}"
                             [headerClass]="'wrapheader-sample-request-grid'" [filterable]="true" [width]="225">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="subCategoryDescription" title="{{sampleRequestTxt.productLbl?sampleRequestTxt.productLbl:sampleRequestGrid.productLbl}}"
                             [headerClass]="'wrapheader-sample-request-grid'" [filterable]="true" [width]="315">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="colorCode" title="{{sampleRequestTxt.colorCodeLbl?sampleRequestTxt.colorCodeLbl:sampleRequestGrid.colorCodeLbl}}"
                             [headerClass]="'wrapheader-sample-request-grid'" [width]="150" [filterable]="true" [sortable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="stockNum" title="{{sampleRequestTxt.stockNumLbl?sampleRequestTxt.stockNumLbl:sampleRequestGrid.stockNumLbl}}"
                             [headerClass]="'wrapheader-sample-request-grid'" [width]="75" [filterable]="false" [sortable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column media="(min-width: 1050px)" field="quantity" title="{{sampleRequestTxt.quantityLbl?sampleRequestTxt.quantityLbl:sampleRequestGrid.quantityLbl}}"
                             [headerClass]="'wrapheader-sample-request-grid'" [filterable]="true" [width]="130">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column [width]="135" field="onBackOrder" [headerClass]="'wrapheader-sample-request-grid'" title="{{sampleRequestTxt.onBackOrderLbl?sampleRequestTxt.onBackOrderLbl:sampleRequestGrid.onBackOrderLbl}}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="red" *ngIf="dataItem.onBackOrder">On Backorder</span>
            </ng-template>
          </kendo-grid-command-column>
          <kendo-grid-command-column media="(min-width: 1050px)" [width]="80"
                                     [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
            <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
              <button class="k-button k-grid-remove-command " (click)="deleteSample(rowIndex)">
                <span class="k-icon k-i-trash">
                </span>
              </button>
            </ng-template>
          </kendo-grid-command-column>
          <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>-->
        </kendo-grid>
      </section>
      <div class="row">
        <div class="col-12 center">
          <button kendoButton primary="true" class="m-3" (click)="continueToAddressPanel()">
            {{sampleRequestTxt.continueLbl?sampleRequestTxt.continueLbl:sampleRequestGrid.continueLbl}}
          </button>
        </div>
      </div>

    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item [expanded]="false">
    <ng-template kendoPanelBarItemTitle>
      <span>{{sampleRequestTxt.placeOrderLbl?sampleRequestTxt.placeOrderLbl:sampleRequestGrid.placeOrderLbl}}</span>
      <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
            *ngIf="!shippingDetails.isShippingDetailsPanelValid && shippingDetails.isSubmitted"></span>
      <span class="k-icon k-i-check-circle k-i-checkmark-circle"
            *ngIf="shippingDetails.isShippingDetailsPanelValid && shippingDetails.isSubmitted"
            style="color:green;font-weight:600"></span>
    </ng-template>
    <ng-template kendoPanelBarContent>
      <form [formGroup]="shippingDetailsForm">
        <div class="row top">
          <div class="col-sm-1 paddingZero"></div>
          <div class="col-sm-10 paddingZero">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.companyNameLbl?sampleRequestTxt.companyNameLbl:shippingDetails.companyNameLbl}}<span class="requiredField">*</span></label>
                  <input type="text" kendoTextBox formControlName="companyName"
                         class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyCompanyName && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.addressLine1Lbl?sampleRequestTxt.addressLine1Lbl:shippingDetails.addressLine1Lbl}}<span class="requiredField">*</span></label>
                  <input type="text" kendoTextBox formControlName="addressLine1"
                         class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyAddress1 && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                </div>
                <div class="form-group">
                  <label class="lbl">
                    {{sampleRequestTxt.addressLine2Lbl?sampleRequestTxt.addressLine2Lbl:shippingDetails.addressLine2Lbl}}
                  </label>
                  <input type="text" kendoTextBox formControlName="addressLine2"
                         class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyAddress2 && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                </div>
                <div class="form-group">
                  <label class="lbl">
                    {{sampleRequestTxt.cityLbl?sampleRequestTxt.cityLbl:shippingDetails.cityLbl}}{{justTest}}
                    <span class="requiredField">*           </span>
                    <span style="visibility: hidden;">  Test only </span>
                  </label>
                  <input type="text" kendoTextBox formControlName="city"
                         class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyCity && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.stateLbl?sampleRequestTxt.stateLbl:shippingDetails.stateLbl}}<span class="requiredField">*</span></label>
                  <kendo-dropdownlist class="kendoInput"
                                      formControlName="state"
                                      [data]="getState"
                                      [textField]="'stateDescription'"
                                      [valueField]="'stateCode'" (valueChange)="getCountryByState($event)" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyState && shippingDetails.isSubmitted}">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.zipCodeLbl?sampleRequestTxt.zipCodeLbl:shippingDetails.zipCodeLbl}}<span class="requiredField">*</span></label>
                  <input type="text" kendoTextBox formControlName="zipCode"
                         class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyZipCode && shippingDetails.isSubmitted}" />
                </div>
                <div class="form-group" *ngIf="isCountryData">
                  <label class="lbl">{{sampleRequestTxt.countryLbl?sampleRequestTxt.countryLbl:shippingDetails.countryLbl}}<span class="requiredField">*</span></label>
                  <kendo-dropdownlist class="kendoInput"
                                      formControlName="country"
                                      [data]="getCountry"
                                      [textField]="'countryName'"
                                      [valueField]="'countryCode'" (blur)="validateShippingDetailsForm()" [ngStyle]="isCountryData==true ? {'pointer-events': 'none','opacity': '0.6'} : {}" [disabled]="isCountryData" [ngClass]="{'borderRed':shippingDetails.isEmptyCountry && shippingDetails.isSubmitted}">
                  </kendo-dropdownlist>

                </div>

              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.jobNameLbl?sampleRequestTxt.jobNameLbl:shippingDetails.jobNameLbl}}<span class="requiredField">*</span></label>
                  <input type="text" kendoTextBox formControlName="jobName"
                         class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyJobName && shippingDetails.isSubmitted}" />
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.contactFirstName?sampleRequestTxt.contactFirstNameLbl:shippingDetails.contactFirstNameLbl}}<span class="requiredField">*</span></label>
                  <input type="text" kendoTextBox formControlName="contactFirstName"
                         class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptycontactFirstName && shippingDetails.isSubmitted}" />
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.contactLastName?sampleRequestTxt.contactLastNameLbl:shippingDetails.contactLastNameLbl}}<span class="requiredField">*</span></label>
                  <input type="text" kendoTextBox formControlName="contactLastName"
                         class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptycontactLastName && shippingDetails.isSubmitted}" />
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.phoneNumberLbl1?sampleRequestTxt.phoneNumberLbl1:shippingDetails.phoneNumberLbl1}}<span class="requiredField">*</span></label>
                  <kendo-numerictextbox formControlName="phoneNumber" [maxlength]="10"
                                        [format]="'#'" [spinners]="false"
                                        class="kendoInput sample-user-phone-number" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':(shippingDetails.isEmptyPhoneNumber || shippingDetails.isInvalidPhoneNumber) && shippingDetails.isSubmitted}"></kendo-numerictextbox>
                  <span title="{{sampleRequestTxt.phoneNumberValidationLbl?sampleRequestTxt.phoneNumberValidationLbl:sampleRequestGrid.phoneNumberValidationLbl}}"
                        *ngIf="shippingDetails.isInvalidPhoneNumber" kendoTooltip
                        class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                </div>
                <div class="form-group">
                  <label class="lbl">{{sampleRequestTxt.ccEmailLbl?sampleRequestTxt.ccEmailLbl:shippingDetails.ccEmailLbl}}</label>
                  <input type="text" kendoTextBox formControlName="ccEmail"
                         class="kendoInput" (blur)="validateShippingDetailsForm()" />
                  <span title="{{sampleRequestTxt.ccEmailValidationLbl1?sampleRequestTxt.ccEmailValidationLbl1:sampleRequestGrid.ccEmailValidationLbl1}}"
                        *ngIf="shippingDetails.isInvalidCCEmail" kendoTooltip
                        class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                </div>

                <div class="form-group" *ngIf="getSampleRegion">
                  <div *ngIf="isOnlyExtUser">
                    <label class="lbl">{{sampleRequestTxt.regionLbl?sampleRequestTxt.regionLbl:shippingDetails.regionLbl}}<span class="requiredField">*</span></label>
                    <kendo-dropdownlist class="kendoInput"
                                        formControlName="region"
                                        [data]="getSampleRegion"
                                        [textField]="'regionDescription'"
                                        [valueField]="'regionCode'" [ngStyle]=" {'pointer-events': 'none','opacity': '0.6'}"  (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyRegion && shippingDetails.isSubmitted}">
                    </kendo-dropdownlist>
                  </div>
                  <div *ngIf="!isOnlyExtUser">
                    <label class="lbl">{{sampleRequestTxt.regionLbl?sampleRequestTxt.regionLbl:shippingDetails.regionLbl}}<span class="requiredField">*</span></label>
                    <kendo-dropdownlist class="kendoInput"
                                        formControlName="region"
                                        [data]="getSampleRegion"
                                        [textField]="'regionDescription'"
                                        [valueField]="'regionCode'" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyRegion && shippingDetails.isSubmitted}">
                    </kendo-dropdownlist>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12">*{{sampleRequestTxt.info1Lbl?sampleRequestTxt.info1Lbl:shippingDetails.info1Lbl}}</div>
              <div class="col-xs-12 col-sm-12">**{{sampleRequestTxt.info2Lbl?sampleRequestTxt.info2Lbl:shippingDetails.info2Lbl}}</div>
              <div class="col-xs-12 col-sm-12">***{{sampleRequestTxt.info3Lbl?sampleRequestTxt.info3Lbl:shippingDetails.info3Lbl}}</div>
            </div>
            <div class="col-12 center">
              <button kendoButton class="m-3" (click)="cancelPlaceOrder()" [disabled]="saveInProcess">
                {{sampleRequestTxt.cancelLbl?sampleRequestTxt.cancelLbl:sampleRequestGrid.cancelLbl}}
              </button>
              <button kendoButton class="m-3 btn btn-success" (click)="placeOrder()" [disabled]="saveInProcess">
                {{sampleRequestTxt.placeOrderLbl?sampleRequestTxt.placeOrderLbl:sampleRequestGrid.placeOrderLbl}} <kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
          <div class="col-sm-1 paddingZero"></div>
        </div>
      </form>

    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>
<section>
  <kendo-dialog [minWidth]="200" [minHeight]="100" title="Sample Request" *ngIf="confirmDialogOpened" (close)="confirmDialogClose()">
    {{sampleRequestTxt.submitResponseLbl1?sampleRequestTxt.submitResponseLbl1:sampleRequestGrid.submitResponseLbl1}}
    <strong>
      #{{sampleRequestOrderNum}}
    </strong>
  </kendo-dialog>
</section>
<section class="dialogSection">
  <kendo-dialog class="sample-request-img-popup" *ngIf="confirmImageDialogOpened" (close)="confirmImageDialogClose()">
    <div style="text-align: center;">
      <div class="k-display-flex justify-content-between float-right sample-request-popup-close">
        <span class="k-icon k-i-close" (click)="confirmImageDialogClose()"></span>
      </div>
      <div class='contentInfobox'>
        <div class="details">
          <img *ngIf="isGridLargerImage" class="grid-img-larger-item" src="{{gridLargerImage}}" />
          <div *ngIf="!isGridLargerImage" class="grid-img-larger-item" style.background-color="{{gridLargerImage}}"></div>
        </div>
      </div>
    </div>
  </kendo-dialog>
</section>
